import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import {RainbowTreasure_Responsive} from "../RainbowTreasure/game_responsive";
export class RainbowTreasureLink_Responsive extends RainbowTreasure_Responsive {

    constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
        super(multigameParams, initData, "RainbowTreasureLink");
    }

}